import React from "react";
import NavbarComponent from '../component/NavbarComponent'

const MusicRooms = () => {
  return (
    <React.Fragment>
    <NavbarComponent />

     <div className="min-h-screen"></div>

     <footer className="border-t-2">
     <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span
            className="text-black text-lg font-bold hover:text-blue-300 "
          
          >
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
     </footer>
  </React.Fragment>
  );
};

export default MusicRooms;
